import { render, staticRenderFns } from "./EditPublications.vue?vue&type=template&id=fb2e2f68&"
import script from "./EditPublications.vue?vue&type=script&lang=js&"
export * from "./EditPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports